import BaseDropdown from './dropdown';

class ColumnsDropdown extends BaseDropdown {
  constructor(props) {
    super(props);

    this.type = 'columns';
    this.label = 'Columns';
    // List item can be targeted by the column name, e.g. $('.dropdown-item.clicks')
    this.identifierField = 'name';
    this.hasSearch = true;
    this.dropdownDiv = null;

    this.previousColumns = this.props.items;

    this.state = {
      columns: this.props.items,
      opened: false,
      focusIndex: null,
    };
  }

  update() {
    const selectedColumns = this.state.columns
      .filter(column => column.selected)
      .map(column => column.label)
      .join(',');
    this.AnalyticService.trackEvent(
      this.props.gaEvent.category,
      'Execute',
      `${this.props.gaEvent.label} ${selectedColumns}`,
    );

    // Update megatable with new columns
    this.props.updateColumns(this.state.columns);
  }
}

export default ColumnsDropdown;
